export default [
  {
    value: 'too_big',
    name: 'Trop grand',
    id: 1
  },
  {
    value: 'too_small',
    name: 'Trop petit',
    id: 2
  },
  {
    value: 'is_not_suitable',
    name: 'Ne convient pas',
    id: 3
  },
  {
    value: 'damaged_item',
    name: 'Article endommagé',
    id: 4
  },
  {
    value: 'incorrect_item',
    name: 'Mauvais article livré',
    id: 5
  },
  {
    value: 'other',
    name: 'Autre',
    id: 6
  },
  {
    value: 'color_is_not_suitable',
    name: 'La couleur ne convient pas',
    id: 7
  },
  {
    value: 'cut_is_not_suitable',
    name: 'La coupe ne convient pas',
    id: 8
  },
  {
    value: 'material_is_not_suitable',
    name: 'La matière ne convient pas',
    id: 9
  },
  {
    value: 'ordered_two_different_sizes',
    name: "J'ai commandé 2 tailles différentes",
    id: 10
  },
  {
    value: 'ordered_two_different_colors',
    name: "J'ai commandé 2 couleurs différentes",
    id: 11
  }
];
